import { ToastContainer } from "../../components/Common";
import JobCreatePage from "./page";

const JobCreatePageWrapper = () => {
    return (
        <>
            <div className="page-content">
                <JobCreatePage />
            </div>
            <ToastContainer />
        </>
    );
};

export default JobCreatePageWrapper;
